import { useMemo } from 'react';

import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { getDefaultTopicIndex } from 'pages/ParentHelper/utils';

export const useDisabled = () => {
  const { chatTopics, isLoadingChatTopics, isLoadingAnswer } =
    useParentHelperContext();

  return useMemo(
    () =>
      getDefaultTopicIndex(chatTopics) > -1 ||
      isLoadingChatTopics ||
      isLoadingAnswer,
    [chatTopics, isLoadingChatTopics, isLoadingAnswer],
  );
};
